"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SETTINGS", {
  enumerable: true,
  get: function () {
    return _settings.SETTINGS;
  }
});
exports.driverChatMessageProcessor = exports.operatorChatMessageProcessor = exports.genUnset = exports.BILLING_POSITION_OWNER = exports.BILLING_POSITION = exports.DISCOUNT_CARD_ERROR_TYPES = exports.BONUS_PROGRAM_TARGET = exports.DRIVER_STATUS_COLORS = exports.DRIVER_STATUS = exports.COMMON_CHAT_DESTINATION_TYPE = exports.DRIVER_CONNECTION_STATUS_COLORS = exports.CALCULATION_TYPE = exports.DRIVER_CONNECTION_STATUS = exports.ORDER_STATUS_RANGE = exports.ORDER_STATUS = exports.PROTOCOL = exports.COMMAND = exports.BILLING_TYPE = void 0;

var _settings = require("./settings");

var _range = _interopRequireDefault(require("lodash/range"));

var _misc = require("web-panel-essentials/misc");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @module skat-js/constants
 * @project Web-panel
 * @author Pavel Shabardin (<bigbn@mail.ru>) Thursday, 15th August 2019 3:39:49 pm
 * @copyright 2015 - 2019 SKAT LLC, Delive LLC
 * 
 */

/**
* SKAT Protocol command
* @readonly
* @constant COMMAND
*/
const COMMAND = {
  /** Then alert button was pushed */
  ALERT: 'ALERT',

  /** Authorization */
  LOGIN: 'LGN',

  /** New session identifier */
  SESSION_ID: 'SID',

  /** Error */
  ERROR: 'ERR',

  /** New booking */
  ORDER: 'ORD',

  /** Booking was changed */
  ORDER_UPDATE: 'ORDCH',

  /** Booking state was changed */
  ORDER_STATUS: 'ORDST',

  /** Driver status was changed */
  DRIVER_STATUS: 'DRST',

  /** Driver statuses */
  DRIVERS_STATUSES: 'DRSTS',

  /** Booking confirmation */
  ORDER_CONFIRMED: 'CFRM',

  /** Broadcasted booking to drivers */
  SET_ORDER_ONLINE: 'ONLINEORDER',

  /** Disable broadcast for this booking */
  SET_ORDER_OFFLINE: 'OFFLINEORDER',

  /** Booking received */
  ORDER_RECEIVED: 'RCV',

  /** Get region list */
  GET_REGIONS: 'RGNS',

  /** Booking information */
  REGION_INFO: 'RGN',

  /** Register driver on a region */
  DRIVER_REGISTRATION: 'REG',

  /** Unregister driver on a region */
  DRIVER_UNREGISTRATION: 'UNREG',

  /** Set driver for the booking */
  SET_DRIVER: 'RADIOSETDRIVER',

  /** Remove driver locks */
  DRIVER_UNLOCK: 'UNBAN',

  /** Pass booking to a next driver */
  PASS_TO_NEXT_DRIVER: 'RADIOREJECT',

  /** Switch booking state to "Driver rejected" */
  DRIVER_REJECTED: 'RJCT',

  /** Register driver as "Radio driver" */
  DRIVER_RADIO_REGISTER: 'RADIOREG',

  /** Unregister driver from radio */
  DRIVER_RADIO_UNREGISTER: 'RADIOUNREG',

  /** Recover driver position in queue */
  DRIVER_RECOVER_POSITION: 'RREG',

  /** Incoming chat message */
  INCOMING_MESSAGE: 'SMSOUT',

  /** Outgoing chat message */
  OUTGOING_MESSAGE: 'SMS',

  /** Query for a call */
  CALL_REQUEST: 'RING',
  CALL_END: 'DELRING',

  /** Incoming chat message from driver */
  DRIVER_INCOMING_MESSAGE: 'SMSIN',

  /** New external booking */
  EXTERNAL_ORDER: 'EXTERNALORDER',

  /** Get rate ID with given time */
  RATE_ID: 'RATEID',

  /** Get customer priority value */
  GET_CLIENT_PRIORITY: 'GETPR',

  /** Hide external booking */
  HIDE_EXTERNAL_ORDER: 'HIDEEXTORD',

  /** Disconnect driver */
  KICK: 'KICK',

  /** Request for current pre-orders list */
  GET_PREORDERS: 'GETRESORDS',

  /* Request for already assigned and not-assigned pre-orders */
  GET_PREORDERS_COMBINED: 'GETRESORDS2',

  /* Get unassigned orderders  */
  GET_FREE_ORDERS: 'FO',

  /* Finish active order */
  COMPLETE_ORDER: 'CMPLT',

  /* Oder completetion succes */
  ORDER_SUCCESSFULLY_COMPLETED: 'CMPLTOK',

  /* Get preoreders assigned for current driver */
  REQUEST_FOR_ASSIGNED_PREORDERS: 'GETATTACHEDRES',

  /* Get unassigned drivers */
  REQUEST_FOR_UNASSIGNED_PREORDERS: 'GETFREERES',

  /* Get order receipt */
  REQUEST_FOR_RECEIPT: 'ORDERCHECK',

  /** Send current location */
  SEND_LOCATION: 'GPS',

  /** Get supplimentary services */
  GET_SUPPLIMENTARY_SERVICES: 'GETEXTRAS',

  /** Terminate current session */
  TERMINATE_SESSION: 'EXIT',

  /** Balance update */
  BALANCE: 'BLNC',

  /** Driver on place, awaiting for client */
  AWAITING_CLIENT: 'onplace',
  PREORDER: 'RO',
  ASSIGNED_PREORDER: 'RESORD',

  /** Lock order before edit if possible. If order already locked by somebody else request will return operator ID */
  REQUEST_FOR_ORDER_LOCK: 'TRYORDERLOCK',
  ORDER_UNLOCK: 'DELBLOCK',
  DRIVER_UPDATE: 'UPDDRIVER',
  DRIVER_SET_PROFILE: 'SETPROFILE',
  SEND_SMS: 'SENDSMS',
  SET_CORPORATE_CAR: 'SETCAR',
  UNSET_CORPORATE_CAR: 'CLEARCAR',

  /** Accept unmoderated order */
  ACCEPT_UNMODERATED: 'ACCEPT',

  /** On any server message */
  OPERATOR_WARNING: 'MSG',

  /**
   * A message sent from a channel member (including own messages).
   */
  CHANNEL_CHAT_INCOMING_MESSAGE: 'CHATMSG',

  /**
   * Use context-safe command (request) CHATSEND to send a message
   * Where <context> is a unique integer for saving response context
  */
  CHANNEL_CHAT_SEND_MESSAGE: 'CHATSEND',

  /**
   * A message sent to the channel was delivered (own messages only).
   */
  CHANNEL_CHAT_DELIVERY_REPORT: 'CHATDELIVERED',

  /**
   * The Member is subscribed when the CHATSUBSCR command is received from the Server:
   */
  CHANNEL_CHAT_SUBSCRIBE: 'CHATSUBSCR',

  /**
   * Chat initialization
   */
  CHANNEL_CHAT_INIT: 'CHATINIT',

  /**
   * A message cannot be sent
   */
  CHANNEL_CHAT_SEND_FAILED: 'CHATSENDFAIL',

  /**
   * Use context-safe command (request) CHATRCV to confirm delivery:
   */
  CHANNEL_CHAT: 'CHATRCV',
  NEW_PHOTO_REPORT: 'PHOTONEW',
  PHOTO_LOCK: 'PHOTOLOCK',
  PHOTO_UNLOCK: 'PHOTOUNLOCK',

  /**
   * Retrieve load markup and coefficients
   */
  GET_LOAD_INFO: 'GETLOAD',
  CONNECT_DRIVER_WITH_CLIENT: 'CLIENTCALL',
  ORDER_DIAL: 'ODIAL',
  SUBSCRIBE: 'SUB',
  PHOTO_REPORT_LOCK: 'PHOTO_REPORT_LOCK',
  PHOTO_REPORT_ACCEPT: 'PHOTO_REPORT_ACCEPT',
  PHOTO_REPORT_REJECT: 'PHOTO_REPORT_REJECT',
  CREATE_CITY: 'NEWCITY',
  UPDATE_CITY: 'UPDCITY',
  NEW_AUTO_ANSWERED_CALL: 'NEWCALL',
  SET_AGENT_EXTENSION: 'SETAGENTEXTEN',
  CHAT_HISTORY: 'MSGHISTORY',
  ORDER_SET_DIAL_MARK: 'ORDDIAL'
};
exports.COMMAND = COMMAND;
const COMMON_CHAT_DESTINATION_TYPE = {
  CUSTOM: Symbol('custom'),
  ALL: Symbol('all'),
  QUEUE: Symbol('queue'),
  CITY: Symbol('city')
};
exports.COMMON_CHAT_DESTINATION_TYPE = COMMON_CHAT_DESTINATION_TYPE;

const operatorChatMessageProcessor = (destination, body) => {
  try {
    body = (0, _misc.decodeProtocolMessage)(body);
    const headerEnd = body.indexOf(')');
    const headers = body.substr(1, headerEnd - 1);
    const sender = (0, _misc.replaceAll)(headers, '(', '');
    let cityId = null;
    const serviceId = null;
    const queues = [];

    if (destination.startsWith('^^')) {
      cityId = _misc.CAST.Number(destination.replace('^^', ''));
      destination = 'TO_CITY';
    }

    if (destination.startsWith('__')) {
      queues.push(_misc.CAST.Number(destination.replace('__', '')));
      destination = 'TO_QUEUE';
    }

    const message = body.substr(headerEnd + 2, body.length);
    return {
      sender,
      destination,
      message,
      scope: {
        cityId,
        serviceId,
        queues
      }
    };
  } catch (e) {
    console.error(e);
    return null;
  }
};

exports.operatorChatMessageProcessor = operatorChatMessageProcessor;

const driverChatMessageProcessor = (sender, body, scopeRaw) => {
  const message = (0, _misc.decodeProtocolMessage)(body);
  const destination = 'TO_OPERATORS';
  let scope = {
    cityId: null,
    serviceId: null,
    queues: []
  };

  try {
    scope = typeof scopeRaw === 'object' ? scopeRaw : JSON.parse(scopeRaw);
  } catch (e) {
    console.log(e);
  }

  return {
    sender,
    destination,
    message,
    scope
  };
};

exports.driverChatMessageProcessor = driverChatMessageProcessor;
const PROTOCOL = {
  HANDLER: {
    /**
     * Inokes when auto-ansered call with agent, notification was sent by AGI to a server.
     */
    NEW_AUTO_ANSWERED_CALL: handler => ({
      command: COMMAND.NEW_AUTO_ANSWERED_CALL,
      handler
    }),
    ALERT: handler => ({
      command: COMMAND.ALERT,
      handler: (callSign, longitude, latitude) => handler(callSign, _misc.CAST.Number(longitude), _misc.CAST.Number(latitude))
    }),
    SESSION_ID: handler => ({
      command: COMMAND.SESSION_ID,
      handler
    }),
    OPERATOR_LOGIN: handler => ({
      command: COMMAND.LOGIN,
      handler: JSONPayload => {
        const {
          sessionId,
          timestamp
        } = JSON.parse(JSONPayload);
        handler(sessionId, timestamp);
      }
    }),
    INCOMING_MESSAGE: handler => {
      return {
        command: COMMAND.INCOMING_MESSAGE,
        handler: (dst, body) => {
          const processedData = operatorChatMessageProcessor(dst, body);

          if (processedData) {
            const {
              sender,
              destination,
              message,
              scope
            } = processedData;
            handler(sender, destination, message, scope);
          }
        }
      };
    },
    DRIVER_INCOMING_MESSAGE: handler => {
      return {
        command: COMMAND.DRIVER_INCOMING_MESSAGE,
        handler: (sender, body, scopeRaw) => {
          const processedData = driverChatMessageProcessor(sender, body, scopeRaw);

          if (processedData) {
            const {
              sender,
              destination,
              message,
              scope
            } = processedData;
            handler(sender, destination, message, scope);
          }
        }
      };
    },
    UPDATE_CITY: handler => {
      return {
        command: COMMAND.UPDATE_CITY,
        handler: payload => {
          const {
            cityId
          } = JSON.parse(payload);
          handler(cityId);
        }
      };
    }
  },
  COMMAND: {
    /**
     * Associate softphone number with operator session to make a server to know who is the call owners
     */
    SET_AGENT_EXTENSION: extension => ({
      command: COMMAND.SET_AGENT_EXTENSION,
      args: [extension]
    }),
    ORDER_CREATED: orderId => ({
      command: COMMAND.ORDER,
      args: [orderId]
    }),
    ORDER_DIAL: (orderId, status) => ({
      command: COMMAND.ORDER_DIAL,
      args: [orderId, status]
    }),

    /**
     * Notify server about a new outgoing or incoming call associated with this order
     * to disable "robot" if it was an outgoing call or to write log mark if it was an incoming one
     */
    ORDER_SET_DIAL_MARK: (orderId, incoming) => ({
      command: COMMAND.ORDER_SET_DIAL_MARK,
      args: [orderId, incoming ? 'o' : 'i']
    }),
    OPERATOR_LOGIN: (username, password, version, forceLogin) => ({
      command: COMMAND.LOGIN,
      args: [username, password, version, forceLogin ? '1' : '']
    }),
    OUTGOING_MESSAGE: (destinationType, destinationTarget, message) => {
      const destinations = {
        // $FlowFixMe
        [COMMON_CHAT_DESTINATION_TYPE.CUSTOM]: v => v,
        // $FlowFixMe
        [COMMON_CHAT_DESTINATION_TYPE.ALL]: v => '',
        // $FlowFixMe
        [COMMON_CHAT_DESTINATION_TYPE.QUEUE]: v => ['__', v].join(''),
        // $FlowFixMe
        [COMMON_CHAT_DESTINATION_TYPE.CITY]: v => ['^^', v].join('')
      };
      return {
        command: COMMAND.OUTGOING_MESSAGE,
        // $FlowFixMe
        args: [destinations[destinationType](destinationTarget), (0, _misc.encodeProtocolMessage)(message)]
      };
    }
  },
  REQUEST: {
    /**
     * Request to fetch last global chat messages
     */
    CHAT_HISTORY: () => ({
      command: COMMAND.CHAT_HISTORY,
      args: []
    }),
    REJECT_PHOTO_REPORT: (reportId, reason) => ({
      command: COMMAND.PHOTO_REPORT_REJECT,
      args: [{
        uuid: reportId,
        reason: reason
      }]
    }),
    ACCEPT_PHOTO_REPORT: reportId => ({
      command: COMMAND.PHOTO_REPORT_ACCEPT,
      args: [reportId]
    }),
    LOCK_PHOTO_REPORT: reportId => ({
      command: COMMAND.PHOTO_REPORT_LOCK,
      args: [reportId]
    }),
    REQUEST_CALL: phoneNumber => ({
      command: COMMAND.CALL_REQUEST,
      args: [{
        cid: phoneNumber
      }]
    }),
    LOCK_ORDER: orderId => ({
      command: COMMAND.REQUEST_FOR_ORDER_LOCK,
      args: [{
        orderId: _misc.CAST.Number(orderId)
      }]
    }),
    ACCEPT_UNMODERATED_ORDER: orderId => ({
      command: COMMAND.ACCEPT_UNMODERATED,
      args: [{
        orderId: _misc.CAST.Number(orderId)
      }]
    }),
    CONNECT_DRIVER_WITH_CLIENT: orderId => ({
      command: COMMAND.CONNECT_DRIVER_WITH_CLIENT,
      args: [{
        order: orderId
      }]
    }),
    SET_DRIVER_PROFILE: (driverId, profileId) => ({
      command: COMMAND.DRIVER_SET_PROFILE,
      args: [{
        driver_id: driverId,
        profile_id: profileId
      }]
    }),
    GET_DUTY_LOAD_INFO: (serviceId, queueId, regionId) => ({
      command: COMMAND.GET_LOAD_INFO,
      args: [{
        queueId,
        serviceId,
        regionId
      }]
    }),
    GET_DRIVERS_STATUSES: () => ({
      command: COMMAND.DRIVERS_STATUSES,
      args: []
    }),
    CHANNEL_CHAT_INIT: (group, id) => ({
      command: COMMAND.CHANNEL_CHAT_INIT,
      args: [{
        channel: {
          group,
          id
        }
      }]
    }),
    CHANNEL_CHAT_SEND_MESSAGE: (group, id, text) => ({
      command: COMMAND.CHANNEL_CHAT_SEND_MESSAGE,
      args: [{
        channel: {
          group,
          id
        },
        message: {
          text
        }
      }]
    }),
    SEND_SMS: (destination, message) => ({
      command: COMMAND.SEND_SMS,
      args: [{
        phones: destination,
        message
      }]
    }),
    GET_CLIENT_PRIORITY: (phone, source, serviceId) => ({
      command: COMMAND.GET_CLIENT_PRIORITY,
      args: [{
        clientPhone: phone,
        source,
        serviceId
      }]
    }),
    CREATE_CITY: (name, lon, lat, address, countryCode) => ({
      command: COMMAND.CREATE_CITY,
      args: [{
        name,
        lon,
        lat,
        address,
        countryCode
      }]
    })
  }
  /**
  * SKAT Booking statuses
  * @constant ORDER_STATUS
  * @readonly
  */

};
exports.PROTOCOL = PROTOCOL;
const ORDER_STATUS = {
  /** Order is not being processed by server */
  NOT_REGISTERED: 0,

  /** Order has been sent to driver */
  SENT_TO_DRIVER: 1,

  /** Order has been attached to driver */
  CONFIRMED: 2,

  /** Driver is waiting for client */
  AWAITING_CLIENT: 3,

  /** Order is being processed */
  IN_PROCESS: 4,

  /** Order has been received from driver */
  RECEIVED_BY_DRIVER: 5,

  /** Driver is waiting for client. Free waiting time is out */
  AWAITING_CLIENT_LONG: 7,

  /** Order is available for taking for a long enough time */
  FREE_LONG: 8,

  /** Order is available for taking */
  FREE: 9,

  /** Client has been notified that order is taken by a driver */
  CONFIRMED_CLIENT_NOTIFIED: 10,

  /** Client has been notified that driver is waiting for him */
  AWAITING_CLIENT_NOTIFIED: 11,

  /** Client does not answer calls. Operator action required */
  NO_REPLY: 16,

  /** Order has been cancelled by client. Operator action required */
  CANCELLED_BY_CLIENT: 19,

  /** TODO */
  AWAITING_DRIVER_NOTIFICATION: 30,

  /** Order is available to be manually sent to drivers */
  ORDER_ON_RADIO: 35,

  /** Preorder is available to be manually sent to drivers */
  PREORDER_ON_RADIO: 36,

  /** Equivalent to FREE for preorder */
  PREORDER_FREE: 50,

  /** Preorder has been attached to a driver */
  PREORDER_ATTACHED: 51,

  /** Confirmation has been requested from driver */
  PREORDER_CONFIRM_REQUESTED: 52,

  /** Preorder has been confirmed by driver */
  PREORDER_CONFIRM_SUCCESSFUL: 53,

  /** Client has been notified that preorder has been attached */
  PREORDER_ATTACHED_NOTIFIED: 54,

  /** Preorder has been attached. Client notified */
  PREORDER_ATTACHED_NOTIFY_PROCESS: 55,

  /** Preorder has attached. Client notification in process */
  PREORDER_CLIENT_CANCELLED: 56,

  /** Preorder confirmation has been rejected */
  PREORDER_CONFIRM_REJECTED: 58,

  /** Preorder confirmation has been timed out */
  PREORDER_CONFIRM_TIMEOUT: 59,

  /** Order has been bound to driver */
  BOUND: 60,

  /** Looking for driver for the order */
  LOOKING_FOR_DRIVER: 65,

  /** Awaiting being accepted by operator */
  AWAITING_MODERATION: 80,

  /** Order has been completed. Payment has not been received yet */
  AWAITING_PAYMENT: 87,

  /** Order has been rejected by driver. Operator action required */
  REJECTED_BY_DRIVER: 88,

  /** Order has been completed. Operator action required */
  AWAITING_COMPLETION: 89,

  /** Order has been removed from processing */
  DONE_REMOVED: 91,

  /** Order has been removed from processing with reason "Client has not paid" */
  DONE_NOT_PAID: 92,

  /** Order has been removed from processing with reason "No cars available" */
  DONE_NO_CARS: 93,

  /** Order has been removed from processing with reason "Client does not accept calls" */
  DONE_CALL_FAILED: 94,

  /** Order has been removed from processing with reason "Client cancelled order" */
  DONE_CANCELLED: 95,

  /** Order has been removed from processing with reason "Operator has rejected this order" */
  DONE_OPERATOR_REJECTED: 97,

  /** Order has been removed from processing with reason "Driver has rejected this order" */
  DONE_DRIVER_REJECTED: 99,

  /** Order has been completed succefully and removed from processing */
  DONE_SUCCESSFUL: 100
  /**
   * Order status ranges, grouped by completion state
   * @readonly
   * @constant ORDER_STATUS_RANGE
   */

};
exports.ORDER_STATUS = ORDER_STATUS;
const ORDER_STATUS_RANGE = {
  /** Active orders */
  NOT_DONE: (0, _range.default)(0, 90),

  /** Completed orders */
  DONE: (0, _range.default)(90, 101),

  /** Orders in failed state */
  DONE_NOT_SUCCESSFUL: (0, _range.default)(90, 100)
  /**
  * Order billing type
  
  * @constant BILLING_TYPE
  */

};
exports.ORDER_STATUS_RANGE = ORDER_STATUS_RANGE;
const BILLING_TYPE = {
  /** todo */
  NONE: 0,

  /** todo */
  WAIT_COMPENSATE_NONCASH: 1,

  /** todo */
  WAIT_NONCASH: 2,

  /** todo */
  COMPENSATE: 128,

  /** todo */
  COMPENSATE_NONCASH: 129,

  /** todo */
  NONCASH: 130
  /**
   * billing_type in order_billing
   * @constant BILLING_POSITION
   */

};
exports.BILLING_TYPE = BILLING_TYPE;
const BILLING_POSITION = {
  BASE: 'base',
  DISCOUNT: 'discount',
  ADDRESS: 'address',
  OPERATOR: 'operator',
  EXTRA: 'extra',
  EXTRA_RATE: 'extra_rate'
};
exports.BILLING_POSITION = BILLING_POSITION;
const BILLING_POSITION_OWNER = {
  CUSTOMER: 'customer'
  /**
  * Driver connection status
  * @readonly
  * @constant DRIVER_CONNECTION_STATUS
  */

};
exports.BILLING_POSITION_OWNER = BILLING_POSITION_OWNER;
const DRIVER_CONNECTION_STATUS = {
  /** Not connected */
  OFFLINE: 0,

  /** Connection problems */
  PING_TIMEOUT: 1,

  /** Active */
  ONLINE: 2
};
exports.DRIVER_CONNECTION_STATUS = DRIVER_CONNECTION_STATUS;
const DRIVER_CONNECTION_STATUS_COLORS = {
  [DRIVER_CONNECTION_STATUS.ONLINE]: '#C6F06E',
  [DRIVER_CONNECTION_STATUS.OFFLINE]: '#FFF',
  [DRIVER_CONNECTION_STATUS.PING_TIMEOUT]: '#FCC'
  /**
   * Unified driver status
   * @readonly
   * @constant DRIVER_STATUS
   */

};
exports.DRIVER_CONNECTION_STATUS_COLORS = DRIVER_CONNECTION_STATUS_COLORS;
const DRIVER_STATUS = {
  /** Not connected */
  OFFLINE: 0,

  /** Connection problems */
  PING_TIMEOUT: 1,

  /** Active */
  ONLINE: 2,
  BUSY: 3,
  BANNED: 255
};
exports.DRIVER_STATUS = DRIVER_STATUS;
const DRIVER_STATUS_COLORS = {
  [DRIVER_STATUS.ONLINE]: '#C6F06E',
  [DRIVER_STATUS.OFFLINE]: '#FFF',
  [DRIVER_STATUS.PING_TIMEOUT]: '#CCC',
  [DRIVER_STATUS.BUSY]: '#FCC',
  [DRIVER_STATUS.BANNED]: '#FD8'
  /**
  * Calculation type
  * @readonly
  * @constant CALCULATION_TYPE
  */

};
exports.DRIVER_STATUS_COLORS = DRIVER_STATUS_COLORS;
const CALCULATION_TYPE = {
  /** Taximeter */
  TAXIMETER: 'taxometr',

  /** Tariff grid */
  TABLE: 'table',

  /** Pre-cost */
  ROUTE: 'route',

  /** Taximeter with pre-cost */
  TAXIMETER_EXTENDED: 'taxometrEx'
  /**
   * Bonus program target
   */

};
exports.CALCULATION_TYPE = CALCULATION_TYPE;
const BONUS_PROGRAM_TARGET = {
  DISCOUNT: 'discount',

  /** Automatically applied discounts */
  DISCOUNT_AUTO: 'auto_discount',
  PERCENT: 'discount_percent',
  PERCENT_AUTO: 'auto_discount_percent'
};
exports.BONUS_PROGRAM_TARGET = BONUS_PROGRAM_TARGET;
const DISCOUNT_CARD_ERROR_TYPES = {
  CARD_NO_ERROR: 0,
  CARD_INACTIVE: 1,
  CARD_TIME_EXPIRED: 2,
  CARD_TIME_NOT_STARTED: 3,
  CARD_USAGE_EXPIRED: 4,
  CARD_IN_USE: 5
};
exports.DISCOUNT_CARD_ERROR_TYPES = DISCOUNT_CARD_ERROR_TYPES;

const genUnset = __ => {
  return {
    CITY: {
      id: -1,
      name: __('ALL_CITIES'),
      timezoneName: 'Europe/London',
      mapZoomLevel: 11,
      isWorkAllowed: true
    },
    QUEUE: {
      id: -1,
      name: __('ALL_QUEUES'),
      cityId: -1,
      description: null
    },
    GROUP: {
      id: -1,
      value: 0,
      name: __('ALL_GROUPS'),
      calculation: CALCULATION_TYPE.TAXIMETER,
      calculation2: CALCULATION_TYPE.TAXIMETER,
      limit: 0
    },
    SERVICE: {
      id: -1,
      name: __('ALL_SERVICES'),
      cityId: -1,
      queueId: -1,
      defaultRateId: -1,
      backgroundColor: 'white',
      calculation: 'taximeter',
      foregroundColor: 'black'
    },
    RATE: {
      id: -1,
      name: __('NO_RATE'),
      serviceId: -1,
      minFare: 0,
      farePerKm: 0,
      markup: 0,
      stationaryFare: 0,
      pickUp: null,
      waitingRate: 0,
      changeoverSpeed: 0,
      trafficLightPause: 0,
      private: false,
      enableAutoStationaryFare: false,
      showMinFare: false,
      roundTo: 0
    },
    OPERATOR: {
      id: -1
    }
  };
};

exports.genUnset = genUnset;